const getColorSet = (colors, colorSets, clientCi) => {
  // Do something with colorSet here or leave it as it is
  return colorSets;
};

export { getColorSet };
